import _Object$assign from 'babel-runtime/core-js/object/assign';

import _ from 'lodash';

export default {
  name: 'BasePackageTagManager',

  componentName: 'BasePackageTagManager',

  props: {
    formValue: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    onConfirm: {
      type: Function,
      default: function _default() {}
    }
  },

  data: function data() {
    return {
      visible: false,
      innerFormConfig: {
        inline: false,
        labelPosition: 'top',
        labelWidth: '',
        size: 'small',
        statusIcon: true,
        disabled: false
      },
      formItemList: [{
        label: '配置标签',
        prop: 'tag_ids',
        type: 'business',
        subtype: 'base-package-tag-checkbox'
      }],
      innerFormValue: {
        tag_ids: []
      },
      tempFormValue: null,
      loading: false
    };
  },


  computed: {
    disabled: function disabled() {
      return _.isEqual(this.tempFormValue, this.innerFormValue);
    }
  },

  watch: {
    visible: function visible(val) {
      if (val === true) {
        this.innerFormConfig = _Object$assign({}, this.innerFormConfig, this.formConfig);
        this.innerFormValue = _Object$assign({}, this.formValue);
        this.tempFormValue = _.cloneDeep(this.innerFormValue);
      } else {
        this.$refs.form.resetFields();
      }
    }
  },

  mounted: function mounted() {},


  methods: {
    hidePopover: function hidePopover() {
      this.visible = false;
    },
    updateTags: function updateTags() {
      var _this = this;

      this.loading = true;
      this.onConfirm(this.innerFormValue).then(function () {
        _this.hidePopover();
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    setTagsOptions: function setTagsOptions(tagList) {
      tagList = tagList.map(function (item) {
        return {
          value: item.id,
          label: item.name
        };
      });
      this.formItemList[0].params.options = tagList;
    },
    getBasePackageTagList: function getBasePackageTagList() {
      var _this2 = this;

      this.$store.dispatch('GetBasePackageTagList').then(function (res) {
        var tagList = _.get(res, 'data.data.list') || [];
        _this2.setTagsOptions(tagList);
      }).catch(function (error) {
        _this2.$message.error(error.message);
      });
    }
  }
};